var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.schoolInfo.id
    ? _c("main", [
        _c(
          "div",
          { staticClass: "top-banner" },
          [
            _c("el-image", {
              staticClass: "institution-logo",
              attrs: { src: _vm.schoolInfo.logo, fit: "cover" },
            }),
            _c("h1", [
              _c("i", { staticClass: "el-icon-mic" }),
              _c("span", [_vm._v(_vm._s(_vm.schoolInfo.live_title))]),
              _c("i", { staticClass: "el-icon-mic" }),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("Filters", {
              attrs: { "type-list": _vm.typeList, "year-list": _vm.yearList },
              on: { search: _vm.getSearch },
            }),
            _c(
              "div",
              { staticClass: "list-container" },
              _vm._l(_vm.liveList, function (item) {
                return _c("ListCard", {
                  key: item.id,
                  attrs: { "card-data": item },
                })
              }),
              1
            ),
            _c("div", { staticClass: "pagination-ara" }),
          ],
          1
        ),
        _c("div", { staticClass: "bottom-banner" }, [
          _c("span", [
            _vm._v(
              "版权所有©" +
                _vm._s(_vm.schoolInfo.name) +
                " 斯奈特提供在线技术支持"
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }